module.exports = __webpack_public_path__ + "static/media/areas01M.38bee663.jpg";